import { useState } from "react";

const useModal = () => {
  const [isShowing, setIsShowing] = useState(false);
  const [showIndex, setShowIndex] = useState("Login");

  function toggle(index) {
    setIsShowing(!isShowing);
    setShowIndex(index);
    document.body.style.overflow = !isShowing ? "hidden" : "scroll"
  }

  return {
    isShowing,
    toggle,
    showIndex,
  };
};

export default useModal;
